<template>
  <div v-for="(item, index) in list" :key="item.id">
    <!-- 每个卡片和上一个的卡片便宜 top+10 right+10 z-index + 1 -->
    <div class="system-message-notify-expire"
      :style="{ top: `${90 + index * 10}px`, right: `${60 + index * 10}px`, zIndex: `${100 + index}` }">
      <!-- 会员版本到期通知 -->
      <div class="expire-message-content">
        <div class="close-btn" @click="onClose(item.feedId, index)"></div>
        <div class="title">
          <i class="icon"></i>
          <span class="text">{{ item.operateName }}</span>
        </div>
        <div class="content">
          <div class="text">{{ item.content }}</div>
          <div class="create-time">{{ item.createTime }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getUserFeedTimelineList, setRead } from '@/api/message-notify'
import { useWorkspaceStore } from '@/store'

export default {
  name: 'ExpireMessageCards',
  data() {
    return {
      list: [],
      loopTimer: null,
    }
  },
  computed: {
    enterpriseId() {
      const workspaceStore = useWorkspaceStore()
      return workspaceStore.currentWorkspace.workspaceId
    },
  },
  methods: {
    getUnreadExpireMessage() {
      // 系统消息 feedConfigId：原参数值增加类型 69=服务到期通知
      getUserFeedTimelineList({
        category: 0,
        enterpriseId: this.enterpriseId,
      }).then((res) => {
        if (!res || !res.records || !res.records.length) {
          return
        }
        // 过滤出服务到期通知 并且是未读的
        const expireMessageList = res.records.filter((item) => item.feedConfigId === 69 && item.unread === 0)

        // console.log('expireMessageList', expireMessageList)
        if (expireMessageList.length > 0) {
          // 如果不在 list 中，则添加到 list 中
          expireMessageList.forEach((item) => {
            if (!this.list.some((listItem) => listItem.id === item.id)) {
              this.list.push(item)
            }
          })
        }
      })
    },
    onClose(id, index) {
      // 设置已读
      setRead({
        ids: [id],
      }).then(() => {
        this.list.splice(index, 1)
      })
    },
  },
  mounted() {
    this.getUnreadExpireMessage()
    this.loopTimer = setInterval(() => {
      this.getUnreadExpireMessage()
    }, 1000 * 20)
  },
  beforeDestroy() {
    if (this.loopTimer) {
      clearInterval(this.loopTimer)
    }
  },
}
</script>
<style lang="scss" scoped>
.system-message-notify-expire {
  position: absolute;
  top: 80px;
  right: 60px;
  padding: 30px 20px;
  width: 400px;
  height: 160px;
  background-image: url('https://materialdb.zhaoyl.com/fed/system-message-notify-bg.png');
  background-size: cover;
  border-radius: 12px;
  border: 1px solid #FFFFFF;

  .expire-message-content {
    position: relative;

    .close-btn {
      position: absolute;
      top: -16px;
      right: 0;
      width: 20px;
      height: 20px;
      cursor: pointer;

      &::before,
      &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        height: 1px;
        background: #242F57;
        transform-origin: center;

      }

      &::before {
        transform: translate(-50%, -50%) scale(0.8) rotate(45deg);
      }

      &::after {
        transform: translate(-50%, -50%) scale(0.8) rotate(-45deg);
      }
    }

    .title {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 500;
      color: #242F57;

      .icon {
        margin-right: 12px;
        width: 18px;
        height: 18px;

        border-radius: 50%;
        background: #FF6B00;
        position: relative;

        /* 感叹号竖线 */
        &::before {
          content: '';
          position: absolute;
          width: 2px;
          height: 8px;
          background: #fff;
          top: 3px;
          left: 50%;
          transform: translateX(-50%);
        }

        /* 感叹号点 */
        &::after {
          content: '';
          position: absolute;
          width: 2px;
          height: 2px;
          background: #fff;
          border-radius: 50%;
          bottom: 3px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }

    .content {
      margin-top: 10px;
      padding-left: 30px;
      font-size: 12px;
      color: #425466;
      line-height: 18px;

      .create-time {
        margin-top: 10px;
        color: #8FA1B2;
      }
    }
  }
}
</style>